import { styled } from '@mui/material';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useMIDIContext } from '../../../../contexts';
import { useDrumContext } from '../../../../contexts/DrumContext';
import { texts } from '../intl';
export function MidiState() {
    const { inputs } = useMIDIContext();
    const { drum } = useDrumContext();
    if (drum != null) {
        return React.createElement(MidiStateStyle, { className: "MidiState On" },
            React.createElement(StatusSign, { on: true }),
            React.createElement(Typography, { className: "ModuleTitle", variant: "overline2", component: "span", color: "primary" }, drum.label));
    }
    else {
        return React.createElement(MidiStateStyle, { className: "MidiState Off" },
            React.createElement(StatusSign, { on: false }),
            React.createElement(Typography, { className: "ModuleTitle", variant: "overline2", component: "span", color: "primary" }, texts.labels.control.useTheKeyboard));
    }
}
function StatusSign({ on }) {
    return React.createElement("svg", { width: "96", viewBox: "0 0 96 31", fill: "none", style: { fontFamily: 'Bebas Neue', dominantBaseline: 'middle', textAnchor: 'start', fontSize: '18px' } },
        React.createElement("rect", { x: "0.5", y: "4.5", width: "90", height: "20", rx: "2.5", fill: "#424242", stroke: "currentColor" }),
        React.createElement("text", { x: 5, y: 14.5, fill: "currentColor" }, "Midi is"),
        React.createElement("text", { x: 67, y: 14.5, fill: "currentColor" }, on ? 'On' : 'Off'),
        React.createElement(Usb, null));
}
function Usb() {
    return React.createElement("g", { style: { transform: 'translate(46px, 0)' } },
        React.createElement("rect", { x: "2.80762", y: "0.5", width: "12.3846", height: "9.14706", fill: "white", stroke: "currentColor" }),
        React.createElement("rect", { x: "4.61548", y: "3.9707", width: "3.23077", height: "2.64706", fill: "black" }),
        React.createElement("rect", { x: "10.1538", y: "3.9707", width: "3.23077", height: "2.64706", fill: "black" }),
        React.createElement("path", { d: "M0 9.70581H18V25.9999C18 28.2091 16.2091 29.9999 14 29.9999H4C1.79086 29.9999 0 28.2091 0 25.9999V9.70581Z", fill: "currentColor" }));
}
export const MidiStateStyle = styled(Stack)(({ theme }) => ({
    flexDirection: 'column',
    alignItems: 'center',
    padding: `0 ${theme.spacing(4)}`,
    overflow: 'hidden',
    '& .Status': {
        display: 'block'
    },
    '&.On': {
        color: theme.palette.primary.main
    },
    '&.Off': {
        color: theme.palette.secondary.main
    },
    '& .ModuleTitle': {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        textAlign: 'center',
        whiteSpace: 'nowrap',
        lineHeight: 1.4,
        display: 'block',
        width: '100%',
    }
}));
//# sourceMappingURL=MidiState.js.map